import React from "react";

const RightArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="right_arrow_icon"
      data-name="right arrow"
      {...props}
      width={props.width || "20"}
      height={props.height || "21"}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.41083 14.9109L10.5892 16.0892L16.1783 10.5001L10.5892 4.91089L9.41083 6.08922L12.9883 9.66672H5V11.3334H12.9883L9.41083 14.9109Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
};

export default RightArrowIcon;
